<template>
    <Head>
        <title>Транзакции</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <v-navigation/>
        </template>

    </authenticated-layout>

</template>

<script>
import {Head} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Transactions';

export default {
    components: {
        Head,
        AuthenticatedLayout,
        VNavigation,
    },
    props: {
        notifications: Array,
    },
}
</script>
